import React from 'react'

const IconRedArrowV2 = () => {
  return (
    <div>
      <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.28613 5.45996L0.286133 0.459961H10.2861L5.28613 5.45996Z" fill="#EE2534" />
      </svg>
    </div>
  )
}

export default IconRedArrowV2
